define('jquery.ui', [], function () {
  return window.jQuery.ui;
});

